module.exports = __webpack_public_path__ + "static/media/va.a44c6ba9.svg";